import { useEffect, useRef, useState } from "react";

const STATS = [
  {
    label: "Venues Listed",
    value: 500,
    suffix: "+",
    desc: "Cafés, restaurants & nightlife",
  },
  {
    label: "Monthly Users",
    value: 50,
    suffix: "K+",
    desc: "Active explorers across the UAE",
  },
  {
    label: "Emirates Covered",
    value: 6,
    suffix: "",
    desc: "Every emirate in the UAE",
  },
];

function useCountUp(target, duration = 1800, start = false) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!start) return;
    let startTime = null;
    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(Math.floor(eased * target));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [target, duration, start]);
  return count;
}

function StatCard({ stat, index, visible }) {
  const count = useCountUp(stat.value, 1600 + index * 200, visible);

  return (
    <div
      style={{
        flex: 1,
        minWidth: "200px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "0.25rem",
        padding: "1.5rem",
        textAlign: "center",
      }}
    >
      <div
        style={{
          fontFamily: "'Fraunces', serif",
          fontSize: "3.5rem",
          fontWeight: 400,
          lineHeight: 1,
          color: "var(--lp-color-text-dark)",
          minWidth: "4ch",
        }}
      >
        {count}{stat.suffix}
      </div>

      <div
        style={{
          fontFamily: "'Outfit', sans-serif",
          fontWeight: 500,
          fontSize: "1rem",
          color: "var(--lp-color-text-dark)",
          marginTop: "0.5rem",
        }}
      >
        {stat.label}
      </div>

      <div
        style={{
          fontFamily: "'Outfit', sans-serif",
          fontWeight: 300,
          fontSize: "0.85rem",
          color: "var(--lp-color-text-muted)",
        }}
      >
        {stat.desc}
      </div>
    </div>
  );
}

export function LandingTrustSection() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="lp-py-12 lp-px-6 lp-relative lp-z-10" ref={ref}>
      <div className="lp-max-6xl lp-mx-auto">
        <div
          style={{
            position: "relative",
            display: "flex",
            flexWrap: "wrap",
            gap: "2rem",
            justifyContent: "center",
            padding: "2rem 0",
            borderTop: "1px solid var(--lp-color-border)",
            borderBottom: "1px solid var(--lp-color-border)",
          }}
        >
          {STATS.map((stat, idx) => (
            <StatCard key={idx} stat={stat} index={idx} visible={visible} />
          ))}
        </div>
      </div>
    </section>
  );
}
